import { WEBHOOK_HISTORY_FILTER_ITEMS } from 'constants/index';
import useOutsideClick from 'hooks/useOutsideClick';
import moment from 'moment';
import { PopoverComponent } from 'pages/Proposal/components/Publish/modals/PublishModals/PublishedProposalModal/RecipientModals';
import { useEffect, useRef, useState } from 'react';
import { WebhookEventNames } from '../constants';
const { Row, Tooltip, Input, DatePicker, Checkbox, Button, Col } = require('antd');
const {
  CalendarIcon,
  SearchIcon,
  CloseIcon,
  FilterIcon,
  RefreshIcon2,
} = require('components/Icons');

const { RangePicker } = DatePicker;

export const WebhookFilters = ({ onFilterChange, onRefresh, isRefreshing }) => {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState([]);
  const [showSearchBox, showHideSearchBox] = useState(false);
  const [activeFilter, setActiveFilter] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [filterItems, setFilterItems] = useState({
    status: [...WEBHOOK_HISTORY_FILTER_ITEMS],
    events: Object.keys(WebhookEventNames).map((item) => ({
      id: WebhookEventNames[item],
      name: WebhookEventNames[item],
      checked: false,
    })),
  });

  const searchInputRef = useRef(null);
  const inputRef = useRef(null);
  useOutsideClick(searchInputRef, () => showHideSearchBox(false));

  useEffect(() => {
    if (showSearchBox && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 100);
    }
  }, [showSearchBox]);

  const disabledFutureDate = (current) => {
    return (
      current > moment().endOf('day') || current < moment().subtract(14, 'days').startOf('day')
    );
  };

  const closeDatePicker = () => {
    setOpen(false);
  };

  const enableDisableDatePicker = () => {
    if (!open) setOpen(true);
  };

  const onChangeDate = (date) => {
    if (date && date.length) {
      date[0] = date[0]?.startOf('day');
      date[1] = date[1]?.endOf('day');
    }
    setSelectedDate(date);
    onFilterChange(searchValue, date, filterItems);
  };

  const onMenuChange = (filter, item) => {
    const newItems = filterItems[filter].map((filterItem) => {
      if (filterItem.id === item.id) {
        return { ...filterItem, checked: !filterItem.checked };
      }
      return filterItem;
    });
    const newFilterItems = { ...filterItems, [filter]: newItems };
    setFilterItems(newFilterItems);
    onFilterChange(searchValue, selectedDate, newFilterItems);
  };

  return (
    <Row justify="left" align="middle" className="item-filter-menu">
      <RangePicker
        dropdownClassName="single-month-picker"
        disabledDate={disabledFutureDate}
        bordered={false}
        suffixIcon={
          <Tooltip title="Date Filter">
            <CalendarIcon onClick={closeDatePicker} />
          </Tooltip>
        }
        value={selectedDate}
        className="date-picker "
        placeholder={['Start Date', 'End Date']}
        allowClear
        onFocus={enableDisableDatePicker}
        onChange={(value) => {
          onChangeDate(value || []);
          setOpen(false);
        }}
      />
      <Row style={{ flex: 1, gap: '12px' }} wrap={false} align="middle">
        <div className="icons-container">
          <div
            ref={searchInputRef}
            className={`search-proposal-icon ${showSearchBox ? 'showInput' : ''}`}>
            <Input
              ref={inputRef}
              placeholder="Search History"
              allowClear
              autoFocus
              onChange={(e) => {
                setSearchValue(e.target.value);
                onFilterChange(e.target.value, selectedDate, filterItems);
              }}
              suffix={
                <CloseIcon
                  className="search-close-icon"
                  onClick={() => {
                    showHideSearchBox(!showSearchBox);
                  }}
                />
              }
            />
            <Tooltip title="Search History">
              <SearchIcon
                className="content-search-icon"
                onClick={() => showHideSearchBox(!showSearchBox)}
              />
            </Tooltip>
          </div>
        </div>
        <PopoverComponent
          icon={<FilterIcon className={`status-filter ${false ? 'trash-enabled' : ''}`} />}
          content={<FilterContent filterItems={filterItems} onMenuChange={onMenuChange} />}
          trigger="click"
          visible={activeFilter}
          onVisibleChange={(value) => {
            setActiveFilter(value);
          }}
        />
        <Button
          className="medium-btn grey-btn refresh-btn"
          icon={<RefreshIcon2 className={isRefreshing ? 'circle' : ''} />}
          onClick={onRefresh}>
          {isRefreshing ? 'Refreshing...' : 'Refresh'}
        </Button>
      </Row>
    </Row>
  );
};

const FilterContent = ({ filterItems, onMenuChange }) => {
  const menuItems = (
    <Row className="webhook-filter-content">
      {Object.keys(filterItems).map((filters, index) => (
        <Col key={index}>
          <div className="webhook-status-menu border-right">
            <div className="menu-header border-bottom">
              <span className="title">{filters === 'status' ? 'Statuses' : 'Events'}</span>
            </div>
            <div className="menu-item-wrapper">
              {filterItems[filters]?.map((item) => (
                <div key={item.id} className="menu-item">
                  <Checkbox
                    className={`item-text`}
                    checked={item?.checked}
                    onChange={() => onMenuChange(filters, item)}>
                    {item.name}
                  </Checkbox>
                </div>
              ))}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
  return <div>{menuItems}</div>;
};
